import React from "react";
import Nav from "../Navbar/Nav";
import { Box, Stack, Typography } from "@mui/material";
import Footer from "../utils/Footer";

const TnC = () => {
  return (
    <>
      <Stack maxWidth={"1536px"} margin={"0 auto"}>
        <Nav />
        <Stack width={"100%"} alignItems={"center"}>
          <Box
            width={"100%"}
            height={"100%"}
            padding={{ xs: "20px 0px", md: "40px 0px" }}
            sx={{
              backgroundColor: "#00437A",
            }}
          >
            <Stack
              margin={"0 auto"}
              width={"80%"}
              height={"100%"}
              justifyContent={"center"}
              alignItems={"start"}
            >
              <Typography color={"white"} variant="h3">
                Terms & Condition
              </Typography>
            </Stack>
          </Box>

          <Stack
            width={"80%"}
            justifyContent={"center"}
            gap={3}
            marginTop={"30px"}
          >
            <Stack>
              <Typography>
                <b>Confidentiality:-</b> The Customer and{" "}
                <b>Saniiro Technologies Pvt. Ltd.® </b>shall each keep
                confidential and shall not disclose to third party any technical
                or commercial information which it acquires from the other as a
                result of discussions, negotiations and other communications
                between them relating to the product or Services.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Customer Responsibility:-</b> Please note that in case,
                Customer accept the orders from our dealer /sales
                partner/Referral partners, the resulting legal contract is in
                between you and that dealer/sales partner/referral partner, and
                is subject to the terms and conditions of that dealer/sales
                partner/referral partner, which they will advise you of
                themselves. In this case we cannot give any undertaking those
                products you purchase from them & we are not responsible for any
                miss happening occur.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Partner[Dealer/Sales/Referral] Responsibility:- </b> For any
                support/commitment from our side for the end customer ,our
                dealer/sales partner/Referral Partner needs to be clarify before
                the issue of license key. We will not accept any verbal
                commitment/Support, make sure before the issue of license keys
                to the customer it should be clearly mention through mail / in
                order form.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Refund Policy:-</b> After the confirmation of order with
                authorized person seal & signatory, there is no refund policy of
                paid amount against agreement. If you cancel contract between us
                after the acceptance of order, paid amount by you against the
                cancel order will not refundable.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Right to vary the terms & conditions:-</b> We have the right
                to revise and amend these terms and conditions from time to time
                to reflect changes in market conditions affecting our business,
                changes in technology, changes in payment methods, changes in
                relevant laws and regulatory requirements and changes in our
                system's capabilities.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Availability of services: -</b> After the order confirmation
                in written/through mail ,we will intimate our training &
                installation schedule after three days, unless there are
                exceptional circumstances. Ownership of the Products will only
                pass to you when we receive full payment of all sums due in
                respect of the Products as per agreed payment terms.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Product Prices: -</b>Product prices, installation & training
                time reliable to change at any time, but changes will not affect
                orders in respect of which we have already accepted.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Service Agreement: -</b> The Services are rendered subject to
                the conditions ruling from the date of issue of license key.
                Company Provide 1 year Services and Maintenance via Remote
                Control, Email, Phone. If Required On-site support will be
                provided also (terms & condition will be applicable as per SLA).
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Key Deactivation: -</b> Key works according to the terms &
                conditions in between customer &{" "}
                <b>Saniiro Technologies Pvt. Ltd.®</b>
                .In any case if the terms & conditions is overdue, the license
                key will deactivate accordingly after a certain time & it cannot
                be active till the overdue condition will fulfill. If the
                license key is deactivated due to any reason we are not
                responsible for any data loss.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Proposed License Price: -</b> Packed & Customize Software
                License Validity 1 year only. After One year Again New Licenses
                Key will be issued for Next One year on. One year Completion
                Company Give 15 Days Grasse Period for Renewal. After 15 Days
                Software Services and Working will be stopped automatically if
                you not renew your Software license.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Annual Maintenance Contract: -</b> After 1 year Annual
                Maintenance Charges Will be Charged as mentioned in Order Form.
                Annual Maintenance included mobile, phone, email, remote support
                and if required on site support will be provided. Annual
                Maintenance is essential which will include FREE UPGRADES
                provided by our Company, but this will not include and
                customized as additional development required by user. If you
                required any visit of our engineer at your site, charges will be
                applicable as per our Service Level Agreement. Cost of AMC
                charges will be increased 10-15% after two renewal years of AMC.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Payment Terms: -</b> 50% Payment in advance and remaining 50%
                Payment with tax will be paid after installation / training
                Time. If the full Payment not received within 90 days from the
                date of installation then License Key will get automatically
                deactivated. In case the govt. revised the taxes in between
                acceptance of order & before installation of the software, order
                value will revise & customer would accept the revised PO
                accordingly. Payment should be in the Favor of{" "}
                <b>“Saniiro Technologies Pvt. Ltd.®”</b>.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Exclusion:-</b> Cost of third party tool [SMS, Email etc.] is
                not included in proposed price. We will also not provide any
                hardware and Hardware AMC.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Training:-</b> Our standard time of training period is 3-4
                days, whereas the training period defined in order form is final
                period of time for training .We will not accept any verbal
                commitment regarding the time period of training .Please find
                below conditions for more clarification:-
              </Typography>
              <Typography>
                I) Due to client end issue if the training time is extend at the
                training duration from the defined time in order form, extra
                charges will be applicable as per our service level agreement.
              </Typography>
              <Typography>
                II) Once the training is done & customer needs training again,
                in that case extra charges will be applicable as per our service
                level agreement.
              </Typography>
              <Typography>
                III) In case of any natural or manmade calamities like Flood,
                Drought, Fire, Sustained Power Failure, Bandh, Road Blockage,
                Terrorist attacks and threats etc. due to which training is not
                schedule at the defined time it will be understandable from both
                side & will not affect other conditions.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Installation:-</b> At the time of installation ,product
                manpower data entry(E.g. Stock, Recipe entry & All data Etc.),
                will not be provided by the company. For every visit whether it
                is required for installation or at the time period of AMC,
                Lodging, Laundry, Boarding & travelling expense to the staff
                member of our company should be provided by client .
              </Typography>
            </Stack>
            <Stack paddingBottom={"30px"}>
              <Typography>
                <b>
                  Note:-<span style={{ color: "red" }}>*</span>
                </b>{" "}
                Client has to provide all the details like Any Minor Changes and
                New Reports or Some More information In Existing Report. Provide
                Details via soft copy or Other Wise by email only. Any minor
                changes & new reports will be firstly analyzed by our technical
                team whether they are applicable or not, then only the changes
                will be performed accordingly
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Footer />
    </>
  );
};

export default TnC;
